import React from 'react';

import { styled } from '../theme';
import Button from './Button';
import FieldLabel from './FieldLabel';
import FieldStatusText from './FieldStatusText';
import FormGroup from './FormGroup';
import Input from './Input';

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    '> :first-of-type': {
        flex: 1,
    },
});

const StyledInput = styled(Input)(({ theme }) => ({
    fontSize: '1.6rem',
    borderRadius: `${theme.borderRadius.base}px 0 0 ${theme.borderRadius.base}px`,
}));

const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: `0 ${theme.borderRadius.base}px ${theme.borderRadius.base}px 0`,
}));

type Props = {
    name: string;
    label: string;
    value?: string;
    onChange?: (ev: any) => void;
    autoFocus?: boolean;
    buttonLabel: string;
    onButtonClick: () => void;
    error?: string;
};

const FormInputWithButton: React.FC<Props> = ({ onButtonClick, ...props }) => (
    <FormGroup itemsSpacing={5}>
        <FieldLabel>{props.label}</FieldLabel>
        <Container>
            <StyledInput {...props} />
            <StyledButton type="button" onClick={onButtonClick}>
                {props.buttonLabel}
            </StyledButton>
        </Container>
        <FieldStatusText status="error">{props.error}</FieldStatusText>
    </FormGroup>
);

export default FormInputWithButton;
